import 'css-chunksrc/client/scenes/calendar/week/milestone/styles.scss';export default {
  "milestone": "_milestone_l51r0_1",
  "background": "_background_l51r0_8",
  "main": "_main_l51r0_17",
  "icon": "_icon_l51r0_29",
  "name": "_name_l51r0_36"
};